import { Link } from "react-router-dom";
import styles from "./CourseCard.module.css";

const CourseCard = ({ items }) => {
  return (
    <div>
      <div className={styles.cardSection}>
        {items.map((item) => {
          const { id, title, img } = item;
          return (
            <div className={styles.cardContainer} key={id}>
              <div className={styles.card}>
                <img
                  className={styles.cardImg}
                  src={img}
                  alt={title}
                  width={300}
                />
                <p>{title}</p>
                <Link
                  to={`/courses/${id}`}
                  className={`primary-btn ${styles.cardBtn}`}
                >
                  Details
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default CourseCard;
